import React from "react"
import Popup from "../Shared/Popup/Popup";
import BingoCard from "../BingoCard/BingoCard"
import { useCardStore } from "../../stores/cardStore";
import "./WinnerCard.css"


export default function WinnerCardCon() {
  const cards = useCardStore.getState().cards;
  const card = cards[10]
  return (
    <Popup _display={"none"}>
      <div className="winner-card-con">
        <div className="winner-card-header">WINNER CARD -{card.cardId}-</div>
        <BingoCard cardId={card.cardId} numbers={card.numbers} />
      </div>
    </Popup>
  )
}